import { BlockTemplate } from '@common/model/blocks';
import { FC } from 'react';
import { PrimaryInfoContent } from '../ui';

export const blocksConfig: Partial<Record<BlockTemplate, FC<any>>> = {
  [BlockTemplate.primaryInfoContent]: PrimaryInfoContent,
};
